<app-rp-loader></app-rp-loader>
<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div
        class="page-title-box d-sm-flex align-items-center justify-content-between"
      >
        <!--  <h4 class="mb-0 font-size-18">View Faq's</h4> -->
        <app-rp-breadcrumb
          [breadcrumbItems]="breadCrumbItems"
        ></app-rp-breadcrumb>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="wrapper">
          <div class="content-container">
            <div class="card-body" style="height: 600px; overflow-y: auto;scrollbar-width: none; -ms-overflow-style: none; ">
              <accordion
                [closeOthers]="true"
                class="accordion custom-accordian"
                [isAnimated]="true"
              >
                <!-- battery Status report  -->
                <accordion-group
                  *ngIf="
                    role == listOfRoles.SUPERADMIN ||
                    role == listOfRoles.SUPERUSER
                  "
                  [isOpen]="isFirstOpen"
                  heading="1. Battery Status Report"
                  class="accordion-item"
                  #group
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon '
                          : 'mdi mdi-chevron-up accor-plus-icon '
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Project <span class="required">*</span></label
                          >

                          <ng-select
                            [items]="utilitybyProjectsList"
                            placeholder="Select Projects"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="seletedUtilityProject"
                            (change)="onProjectFilterChange($event)"
                            (add)="onSelectProject($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >×</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >×</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              seletedUtilityProject.length == 0 &&
                              ProjectValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ ProjectValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Utility <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="BatteryLevelutilityList"
                            placeholder="Select Utilities"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectedUtility"
                            (change)="
                              onFilterBatteryLevelUtilitiesChange($event)
                            "
                            (add)="onBatteryLevelSelectUtility($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >×</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >×</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              selectedUtility.length == 0 &&
                              utilityValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ utilityValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Battery Level</label>
                          <ng-select
                            [items]="batteryLevel"
                            [(ngModel)]="selectedBatteryLevel"
                            bindLabel="name"
                            bindValue="id"
                            [multiple]="false"
                            [deselectOnClick]="false"
                            [clearable]="false"
                          ></ng-select>
                        </div>
                      </div>

                      <div class="col-lg-3 align-items-start sm-btn mt-4">
                        <button
                          class="btn btn-primary btn-md"
                          style="margin-top: 0px"
                          (click)="export()"
                        >
                          Export
                        </button>
                      </div>
                    </div>
                  </div>
                </accordion-group>

                <!-- Settlemet report -->
                <accordion-group
                  *ngIf="
                    role == listOfRoles.SUPERADMIN ||
                    role == listOfRoles.SUPERUSER
                  "
                  [isOpen]="isopen"
                  heading="2. Settlement Report"
                  class="accordion-item"
                  #group
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon '
                          : 'mdi mdi-chevron-up accor-plus-icon '
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Project<span class="required">*</span></label
                          >
                          <ng-select
                            [items]="projectsList"
                            placeholder="Select Projects"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectedSettlementProject"
                            (change)="onProjectSettlementFilterChange($event)"
                            (add)="onSelectSettlmentProject($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >×</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >×</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              selectedSettlementProject.length == 0 &&
                              ProjectSettlmentValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ ProjectSettlmentValidationMessage }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >payment Date <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control settlement"
                              [value]="
                                settlemetDateRange
                                  ? formatDateRange(settlemetDateRange)
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #settlementPicker="bsDaterangepicker"
                              (onShown)="
                                onRangePickerShown(
                                  settlementPicker,
                                  'settlemetDateRange',
                                  'datePickerConfig'
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  settlementPicker,
                                  'settlemetDateRange'
                                )
                              "
                              [bsConfig]="
                                getRangeConfig(
                                  'settlemetDateRange',
                                  'datePickerConfig'
                                )
                              "
                              [maxDate]="getRangeMaxDate('settlemetDateRange')"
                              [(bsValue)]="settlemetDateRange"
                              (bsValueChange)="
                                onGenericDateRangeChange(
                                  $event,
                                  'settlemetDateRange',
                                  'datePickerConfig'
                                )
                              "
                            />
                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendarsettlement()"
                            ></span>
                            <!-- Clear icon -->
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="settlemetDateRange.length > 0"
                              (click)="clearDateSettlement()"
                            ></span>
                          </div>
                          <div
                            *ngIf="
                              settlemetDateRange.length == 0 &&
                              dateRangeSettlementValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ dateRangeSettlementValidationMessage }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 align-items-start sm-btn mt-4">
                        <button
                          class="btn btn-primary btn-md"
                          style="margin-top: 0px"
                          (click)="exportSettlemet()"
                        >
                          Export
                        </button>
                      </div>
                    </div>
                  </div>
                </accordion-group>

                <!-- Scheduled Billing Report -->
                <accordion-group
                  *ngIf="
                    role == listOfRoles.SUPERADMIN ||
                    role == listOfRoles.SUPERUSER
                  "
                  [isOpen]="isopen"
                  heading="3. Scheduled Billing Report"
                  class="accordion-item"
                  #groupschedulingbilling
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !groupschedulingbilling?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon '
                          : 'mdi mdi-chevron-up accor-plus-icon '
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >BillingType <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="BillingTypeList"
                            placeholder="Select BillingType"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectedScheduledBillingType"
                            (change)="onBillingTypeChange($event)"
                            [multiple]="false"
                            [deselectOnClick]="false"
                            [clearable]="false"
                          >
                          </ng-select>
                          <div
                            *ngIf="
                              selectedScheduledBillingType.length == 0 &&
                              billingtypevalidation
                            "
                            class="text-danger mt-2"
                          >
                            {{ billingtypevalidation }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Project <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="Billing_ProjectsList"
                            placeholder="Select Projects"
                            bindLabel="name"
                            bindValue="projectId"
                            [(ngModel)]="selectedScheduledBillingProject"
                            (change)="
                              onProjectSelectionSchedulingReportChange($event)
                            "
                            (add)="onSelectScheduledBillingProject($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >×</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >×</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              selectedScheduledBillingProject.length == 0 &&
                              validationscheduledBillingProject
                            "
                            class="text-danger mt-2"
                          >
                            {{ validationscheduledBillingProject }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-lg-3"
                        *ngIf="selectedScheduledBillingType == 'Prepaid'"
                      >
                        <div class="mb-3">
                          <label class="form-label"
                            >Billing Date <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control Scheduled"
                              [value]="
                                selectedScheduledBillingDateRange
                                  ? formatDateRange(
                                      selectedScheduledBillingDateRange
                                    )
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #scheduledPicker="bsDaterangepicker"
                              (onShown)="
                                onRangePickerShown(
                                  scheduledPicker,
                                  'selectedScheduledBillingDateRange',
                                  'datePickerscheduledBilling'
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  scheduledPicker,
                                  'selectedScheduledBillingDateRange'
                                )
                              "
                              [bsConfig]="
                                getRangeConfig(
                                  'selectedScheduledBillingDateRange',
                                  'datePickerscheduledBilling'
                                )
                              "
                              [maxDate]="datePickerscheduledBilling.maxDate"
                              [(bsValue)]="selectedScheduledBillingDateRange"
                              (bsValueChange)="
                                onGenericDateRangeChange(
                                  $event,
                                  'selectedScheduledBillingDateRange',
                                  'datePickerscheduledBilling'
                                )
                              "
                            />
                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendarScheduled()"
                            ></span>
                            <!-- Clear icon -->
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="
                                selectedScheduledBillingDateRange.length > 0
                              "
                              (click)="clearDateScheduledBilling()"
                            ></span>
                          </div>
                          <div
                            *ngIf="
                              selectedScheduledBillingDateRange.length == 0 &&
                              dateRangeScheduledBillingValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ dateRangeScheduledBillingValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-lg-3"
                        *ngIf="selectedScheduledBillingType == 'Postpaid'"
                      >
                        <div class="mb-3">
                          <label class="form-label"
                            >Month <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <ng-select
                              [items]="scheduledBillingmonthsList"
                              placeholder="Select Month"
                              [(ngModel)]="selectScheduleBillingMonth"
                              [multiple]="false"
                              [clearable]="false"
                              [deselectOnClick]="false"
                            >
                            </ng-select>
                            <div
                              *ngIf="
                                !selectScheduleBillingMonth &&
                                monthValidationMessage
                              "
                              class="text-danger mt-2"
                            >
                              {{ monthValidationMessage }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12 align-items-center sm-btn mt-4">
                        <div class="col-lg-5 d-flex align-items-center mt-3">
                          <!-- Export Button with Margin (click)="exportOnOffSttausreport() -->
                          <button
                            *ngIf="
                              !isScheduleBilling_Reports_DownloadignInprogress
                            "
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="exportScheduledBillingReport()"
                          >
                            Export
                          </button>

                          <button
                            *ngIf="
                              isScheduleBilling_Reports_DownloadignInprogress
                            "
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="
                              getLatestScheduleBillingReportStatus('getStatus')
                            "
                          >
                            <i class="fas fa-sync-alt mr-2"></i>
                          </button>

                          <div
                            *ngIf="
                              isScheduleBilling_Reports_DownloadignInprogress
                            "
                            class="downloading-status d-flex flex-column align-items-start ml-3"
                            style="margin-left: 25px"
                          >
                            <div class="d-flex align-items-center">
                              <i class="fa fa-spinner fa-spin mr-2"></i>
                              <span>Report Generation In Progress...</span>
                            </div>
                            <small class="text-danger mt-1">
                              <strong>Note:</strong> The requested report is
                              currently being generated. Once completed, you can
                              download it by clicking on the
                              <strong>"Generate Report"</strong> button. Click
                              <i class="fas fa-sync-alt mr-2"></i> Refresh to
                              check the status.
                            </small>
                          </div>

                          <!-- Previous Downloaded File Button with Margin -->
                          <button
                            *ngIf="
                              !hidePreviouseScheduleBilling_Reports_availableBtn &&
                              isScheduleBilling_Reports_DownloadedLinkAvailable
                            "
                            class="btn btn-primary btn-md d-flex align-items-center ml-3"
                            style="margin-left: 10px"
                            (click)="downloadWScheduleBilling_ReportFile()"
                          >
                            <i
                              class="fa fa-file-download mr-2"
                              style="margin-right: 10px"
                            ></i
                            >Generate Report
                          </button>
                        </div>
                      </div>

                      <!-- <div class="col-lg-3  align-items-start sm-btn mt-4">
                        <button class="btn btn-primary btn-md " style="margin-top:0px"
                          (click)="exportScheduledBillingReport()">
                          Export
                        </button>
                      </div> -->
                    </div>
                  </div>
                </accordion-group>

                <!--  ON OFF Status -->
                <accordion-group
                  *ngIf="
                    role == listOfRoles.SUPERADMIN ||
                    role == listOfRoles.SUPERUSER
                  "
                  [isOpen]="isopen"
                  heading="4. On Off Status Report"
                  class="accordion-item"
                  #groupschedulingbilling
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !groupschedulingbilling?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon '
                          : 'mdi mdi-chevron-up accor-plus-icon '
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Project <span class="required">*</span></label
                          >

                          <ng-select
                            [items]="projectsList"
                            placeholder="Select Projects"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectedOnOffStatusProject"
                            (change)="onOffStatusProjectFilterChange($event)"
                            (add)="onSelectONOFFStatusProject($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >×</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >×</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              selectedOnOffStatusProject.length == 0 &&
                              validationONOFFStatusProject
                            "
                            class="text-danger mt-2"
                          >
                            {{ validationONOFFStatusProject }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Status <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="OnOffStatusList"
                            placeholder="Select BillingType"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectedOnOffStatus"
                            [multiple]="false"
                            [deselectOnClick]="false"
                            [clearable]="false"
                          >
                          </ng-select>
                          <div
                            *ngIf="
                              selectedOnOffStatus.length == 0 &&
                              onOffStatusvalidation
                            "
                            class="text-danger mt-2"
                          >
                            {{ onOffStatusvalidation }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >On/Off Date <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control onOff"
                              [value]="
                                selectedOnOffStatusDateRange
                                  ? formatDateRange(
                                      selectedOnOffStatusDateRange
                                    )
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #onOffPicker="bsDaterangepicker"
                              (onShown)="
                                onRangePickerShown(
                                  onOffPicker,
                                  'selectedOnOffStatusDateRange',
                                  'datePickeronoffStatus'
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  onOffPicker,
                                  'selectedOnOffStatusDateRange'
                                )
                              "
                              [bsConfig]="
                                getRangeConfig(
                                  'selectedOnOffStatusDateRange',
                                  'datePickeronoffStatus'
                                )
                              "
                              [maxDate]="
                                getRangeMaxDate('selectedOnOffStatusDateRange')
                              "
                              [(bsValue)]="selectedOnOffStatusDateRange"
                              (bsValueChange)="
                                onGenericDateRangeChange(
                                  $event,
                                  'selectedOnOffStatusDateRange',
                                  'datePickeronoffStatus'
                                )
                              "
                            />
                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendarONOFF()"
                            ></span>
                            <!-- Clear icon -->
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="selectedOnOffStatusDateRange.length > 0"
                              (click)="clearDateOnOffStatusdate()"
                            ></span>
                          </div>
                          <div
                            *ngIf="
                              selectedOnOffStatusDateRange.length == 0 &&
                              dateRangeOnOffStatusValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ dateRangeOnOffStatusValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12 align-items-center sm-btn mt-4">
                        <div class="col-lg-5 d-flex align-items-center mt-3">
                          <!-- Export Button with Margin (click)="exportWalletHistoryReports() -->
                          <button
                            *ngIf="!isonOffStatus_Reports_DownloadignInprogress"
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="exportOnOffSttausreport()"
                          >
                            Export
                          </button>

                          <button
                            *ngIf="isonOffStatus_Reports_DownloadignInprogress"
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="
                              getLatestONOFFStatusReportStatus('getStatus')
                            "
                          >
                            <i class="fas fa-sync-alt mr-2"></i>
                          </button>

                          <div
                            *ngIf="isonOffStatus_Reports_DownloadignInprogress"
                            class="downloading-status d-flex flex-column align-items-start ml-3"
                            style="margin-left: 25px"
                          >
                            <div class="d-flex align-items-center">
                              <i class="fa fa-spinner fa-spin mr-2"></i>
                              <span>Report Generation In Progress...</span>
                            </div>
                            <small class="text-danger mt-1">
                              <strong>Note:</strong> The requested report is
                              currently being generated. Once completed, you can
                              download it by clicking on the
                              <strong>"Generated Report"</strong> button. Click
                              <i class="fas fa-sync-alt mr-2"></i> Refresh to
                              check the status.
                            </small>
                          </div>

                          <!-- Previous Downloaded File Button with Margin -->
                          <button
                            *ngIf="
                              !hidePreviouseonOffStatus_Reports_availableBtn &&
                              isonOffStatus_Reports_DownloadedLinkAvailable
                            "
                            class="btn btn-primary btn-md d-flex align-items-center ml-3"
                            style="margin-left: 10px"
                            (click)="downloadWOnOffStatus_ReportFile()"
                          >
                            <i
                              class="fa fa-file-download mr-2"
                              style="margin-right: 10px"
                            ></i
                            >Generated Report
                          </button>
                        </div>
                      </div>

                      <!-- <div class="col-lg-3  align-items-start sm-btn mt-4">
                        <button class="btn btn-primary btn-md " style="margin-top:0px"
                          (click)="exportOnOffSttausreport()">
                          Export
                        </button>
                      </div> -->
                    </div>
                  </div>
                </accordion-group>

                <accordion-group
                  *ngIf="role === listOfRoles.SUPERADMIN"
                  [isOpen]="false"
                  [heading]="'5. Meter Mapping Report'"
                  class="accordion-item"
                  #group3
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group3?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon'
                          : 'mdi mdi-chevron-up accor-plus-icon'
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Utilities <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="utilityList"
                            placeholder="Select Utilities"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="meterMapping_selectedUtility"
                            (change)="onFilterUtilitiesChange($event)"
                            (add)="onSelectUtilityInMeterMapping($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <!-- Template for displaying selected items with cross icon -->
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <!-- Cross icon to clear the selected item -->
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >×</span
                              >
                            </ng-template>

                            <!-- Multi-label template for displaying multiple selected items -->
                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <!-- Cross icon for removing items -->
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >×</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>

                          <div
                            *ngIf="
                              meterMapping_selectedUtility == 0 &&
                              meterMappingvaliadationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ meterMappingvaliadationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Project <span class="required">*</span></label
                          >

                          <ng-select
                            [items]="utilitybyProjectsList"
                            placeholder="Select Projects"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selecteMappingUtilityProject"
                            (change)="onProjectFilterChange($event)"
                            (add)="onSelectMeterMappingProject($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >×</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >×</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              selecteMappingUtilityProject.length == 0 &&
                              MeterMappingProjectValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ MeterMappingProjectValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 align-items-center sm-btn mt-4">
                        <button
                          class="btn btn-primary btn-md"
                          style="margin-top: 0px"
                          (click)="exportMeterMappingReports()"
                        >
                          Export
                        </button>
                      </div>
                    </div>
                  </div>
                </accordion-group>

                     <accordion-group *ngIf="role === listOfRoles.SUPERADMIN || role === listOfRoles.SUPERUSER" [isOpen]="false"
                  [heading]="role === listOfRoles.SUPERADMIN ? '6. High Consumption Report' : '5. High Consumption Report'"
                  class="accordion-item" #groupHighConsumption>
                  <span accordion-heading class="float-end fs-5 d-flex align-items-center">
                    <i class="mdi font-size-24"
                      [ngClass]="!groupHighConsumption?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon' : 'mdi mdi-chevron-up accor-plus-icon'"></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Project <span class="required">*</span></label>
                          <ng-select [items]="projectsList" placeholder="Select Projects" bindLabel="name"
                            bindValue="id" [(ngModel)]="selectedHighConsumptionProject"
                            (change)="onHighConsumptionProjectFilterChange($event)"
                            (add)="onSelectHighConsumptionProject($event)" [multiple]="true"
                            [deselectOnClick]="true">

                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                              <span class="ng-value-label">{{ item?.name }}</span>
                              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">&times;</span>
                            </ng-template>

                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                              <div class="ng-value" *ngFor="let item of items.slice(0,2)">
                                <span class="ng-value-label" *ngIf="item?.name">{{ item?.name }}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">&times;</span>
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
                              </div>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="selectedHighConsumptionProject.length == 0 && highConsumptionProjectValidationMessage"
                            class="text-danger mt-2">
                            {{ highConsumptionProjectValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Date Range <span class="required">*</span></label>
                          <div class="position-relative">
                            <input type="text" class="form-control highConsumption"
                              [value]="highConsumptionDateRange ? (formatDateRange(highConsumptionDateRange)) : ''"
                              placeholder="Select Date" name="daterange" autocomplete="off" bsDaterangepicker
                              #highConsumptionPicker="bsDaterangepicker"
                              (onShown)="onRangePickerShown(highConsumptionPicker, 'highConsumptionDateRange', 'datePickerConfig')"
                              (onHidden)="onRangePickerHidden(highConsumptionPicker, 'highConsumptionDateRange')"
                              [bsConfig]="getRangeConfig('highConsumptionDateRange', 'datePickerConfig')"
                              [maxDate]="getRangeMaxDate('highConsumptionDateRange')"
                              [(bsValue)]="highConsumptionDateRange"
                              (bsValueChange)="onGenericDateRangeChange($event, 'highConsumptionDateRange', 'datePickerConfig')" />
                            <span class="bx bx-calendar inputIcon" (click)="openCalendarHighConsumption()"></span>
                            <span class="bx bx-x inputIcon clear-icon" *ngIf="highConsumptionDateRange.length > 0"
                              (click)="clearHighConsumptionDate()"></span>
                          </div>
                          <div *ngIf="highConsumptionDateRange.length != 2 && highConsumptionDateRangeValidationMessage"
                            class="text-danger mt-2">
                            {{ highConsumptionDateRangeValidationMessage }}
                          </div>
                        </div>
                      </div>

                     
                      <div class="col-lg-12 align-items-center sm-btn mt-4">
                        <div class="col-lg-5 d-flex align-items-center">
                          <button *ngIf="!isHighConsumption_Reports_DownloadignInprogress"
                            class="btn btn-primary btn-md" [disabled]="false"
                            (click)="exportHighConsumptionReport()">
                            Export
                          </button>

                          <button *ngIf="isHighConsumption_Reports_DownloadignInprogress"
                            class="btn btn-primary btn-md" [disabled]="false"
                            (click)="getLatestHighConsumptionReportStatus('getStatus')">
                            <i class="fas fa-sync-alt mr-2"></i>
                          </button>

                          <div *ngIf="isHighConsumption_Reports_DownloadignInprogress"
                            class="downloading-status d-flex flex-column align-items-start ml-3"
                            style="margin-left:25px">
                            <div class="d-flex align-items-center">
                              <i class="fa fa-spinner fa-spin mr-2"></i>
                              <span>Report Generation In Progress...</span>
                            </div>
                            <small class="text-danger mt-1">
                              <strong>Note:</strong> The requested report is currently being generated. Once completed,
                              you can download it by clicking on the <strong>"Generated Report"</strong> button.
                              Click <i class="fas fa-sync-alt mr-2"></i> Refresh to check the status.
                            </small>
                          </div>

                          <button
                            *ngIf="!hidePreviouseHighConsumption_Reports_availableBtn && isHighConsumption_Reports_DownloadedLinkAvailable"
                            class="btn btn-primary btn-md d-flex align-items-center ml-3" style="margin-left:10px"
                            (click)="downloadHighConsumption_ReportFile()">
                            <i class="fa fa-file-download mr-2" style="margin-right: 10px;"></i>Generated Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </accordion-group>

                <!-- Gateway Status -->
                <accordion-group
                  *ngIf="
                    role == listOfRoles.SUPERADMIN ||
                    role == listOfRoles.SUPERUSER
                  "
                  [isOpen]="false"
                   [heading]="

                    role === listOfRoles.SUPERADMIN

                      ? '7. Gateway Status Report'

                      : '6. Gateway Status Report'

                  "
                  class="accordion-item"
                 #groupGatewayStatus
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                       !groupGatewayStatus?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon '
                          : 'mdi mdi-chevron-up accor-plus-icon '
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Project <span class="required">*</span></label
                          >

                          <ng-select
                            [items]="projectsList"
                            placeholder="Select Projects"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectedGatewayStatusProject"

                            (change)="gatewayStatusProjectFilterChange($event)"

                            (add)="onSelectGatewayStatusProject($event)"

                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >×</span>
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >×</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                             selectedGatewayStatusProject.length == 0 &&

                              validationGatewayStatusProject
                            "
                            class="text-danger mt-2"
                          >
                             {{ validationGatewayStatusProject }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Status <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="GatewayStatusList"
                            placeholder="Select Status"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectedGatewayStatus"
                            [multiple]="false"
                            [deselectOnClick]="false"
                            [clearable]="false"
                          >
                          </ng-select>
                          <div
                            *ngIf="
                             selectedGatewayStatus.length == 0 &&

                              gatewayStatusvalidation
                            "
                            class="text-danger mt-2"
                          >
                                {{ gatewayStatusvalidation }}
                          </div>
                        </div>
                      </div>

                    

                      <div class="col-lg-12 align-items-center sm-btn mt-4">
                        <div class="col-lg-5 d-flex align-items-center">
                          <!-- Export Button with Margin (click)="exportWalletHistoryReports() -->
                          <button
                            *ngIf="!isGatewayStatus_Reports_DownloadignInprogress"
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                             (click)="exportGatewayStatusReport()"
                          >
                            Export
                          </button>

                          <button
                            *ngIf="isGatewayStatus_Reports_DownloadignInprogress"
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="
                              getLatestGatewayStatusReportStatus('getStatus')
                            "
                          >
                            <i class="fas fa-sync-alt mr-2"></i>
                          </button>

                          <div
                            *ngIf="isGatewayStatus_Reports_DownloadignInprogress"
                            class="downloading-status d-flex flex-column align-items-start ml-3"
                            style="margin-left: 25px"
                          >
                            <div class="d-flex align-items-center">
                              <i class="fa fa-spinner fa-spin mr-2"></i>
                              <span>Report Generation In Progress...</span>
                            </div>
                            <small class="text-danger mt-1">
                              <strong>Note:</strong> The requested report is
                              currently being generated. Once completed, you can
                              download it by clicking on the
                              <strong>"Generated Report"</strong> button. Click
                              <i class="fas fa-sync-alt mr-2"></i> Refresh to
                              check the status.
                            </small>
                          </div>

                          <!-- Previous Downloaded File Button with Margin -->
                          <button
                            *ngIf="
                              !hidePreviouseGatewayStatus_Reports_availableBtn &&
                            isGatewayStatus_Reports_DownloadedLinkAvailable
                            "
                            class="btn btn-primary btn-md d-flex align-items-center ml-3"
                            style="margin-left: 10px"
                            (click)="downloadGatewayStatus_ReportFile()"
                          >
                            <i
                              class="fa fa-file-download mr-2"
                              style="margin-right: 10px"
                            ></i
                            >Generated Report
                          </button>
                        </div>
                      </div>

                      <!-- <div class="col-lg-3  align-items-start sm-btn mt-4">
                        <button class="btn btn-primary btn-md " style="margin-top:0px"
                          (click)="exportOnOffSttausreport()">
                          Export
                        </button>
                      </div> -->
                    </div>
                  </div>
                </accordion-group>

                <!-- Prepaid Meter Off Status Report -->
                <accordion-group
                  *ngIf="
                    role == listOfRoles.SUPERADMIN ||
                    role == listOfRoles.SUPERUSER
                  "
                  [isOpen]="isopen"
                  heading="8. Prepaid Meter Off Status Report"
                  class="accordion-item"
                  #groupPrepaidMeterOffStatus
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !groupPrepaidMeterOffStatus?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon '
                          : 'mdi mdi-chevron-up accor-plus-icon '
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Project <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="prepaidMeterOffStatus_ProjectsList"
                            placeholder="Select Projects"
                            bindLabel="name"
                            bindValue="projectId"
                            [(ngModel)]="selectedPrepaidMeterOffStatusProject"
                            (change)="
                              prepaidMeterOffStatusProjectFilterChange($event)
                            "
                            (add)="onSelectPrepaidMeterOffStatusProject($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              selectedPrepaidMeterOffStatusProject.length ==
                                0 &&
                              validationPrepaidMeterOffStatusProject
                            "
                            class="text-danger mt-2"
                          >
                            {{ validationPrepaidMeterOffStatusProject }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Date Range <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control prepaidMeterOffStatus"
                              [value]="
                                selectedPrepaidMeterOffStatusDateRange
                                  ? formatDateRange(
                                      selectedPrepaidMeterOffStatusDateRange
                                    )
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #prepaidMeterOffStatusPicker="bsDaterangepicker"
                              (onShown)="
                                onRangePickerShown(
                                  prepaidMeterOffStatusPicker,
                                  'selectedPrepaidMeterOffStatusDateRange',
                                  'datePickerPrepaidMeterOffStatus'
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  prepaidMeterOffStatusPicker,
                                  'selectedPrepaidMeterOffStatusDateRange'
                                )
                              "
                              [bsConfig]="
                                getRangeConfig(
                                  'selectedPrepaidMeterOffStatusDateRange',
                                  'datePickerPrepaidMeterOffStatus'
                                )
                              "
                              [maxDate]="
                                getRangeMaxDate(
                                  'selectedPrepaidMeterOffStatusDateRange'
                                )
                              "
                              [(bsValue)]="
                                selectedPrepaidMeterOffStatusDateRange
                              "
                              (bsValueChange)="
                                onGenericDateRangeChange(
                                  $event,
                                  'selectedPrepaidMeterOffStatusDateRange',
                                  'datePickerPrepaidMeterOffStatus'
                                )
                              "
                            />
                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendarPrepaidMeterOffStatus()"
                            ></span>
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="
                                selectedPrepaidMeterOffStatusDateRange.length >
                                0
                              "
                              (click)="clearDatePrepaidMeterOffStatus()"
                            ></span>
                          </div>
                          <div
                            *ngIf="
                              selectedPrepaidMeterOffStatusDateRange.length !=
                                2 &&
                              dateRangePrepaidMeterOffStatusValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{
                              dateRangePrepaidMeterOffStatusValidationMessage
                            }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12 align-items-center sm-btn mt-4">
                        <div class="col-lg-5 d-flex align-items-center mt-3">
                          <button
                            *ngIf="
                              !isPrepaidMeterOffStatus_Reports_DownloadignInprogress
                            "
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="exportPrepaidMeterOffStatusReport()"
                          >
                            Export
                          </button>

                          <button
                            *ngIf="
                              isPrepaidMeterOffStatus_Reports_DownloadignInprogress
                            "
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="
                              getLatestPrepaidMeterOffStatusReportStatus(
                                'getStatus'
                              )
                            "
                          >
                            <i class="fas fa-sync-alt mr-2"></i>
                          </button>

                          <div
                            *ngIf="
                              isPrepaidMeterOffStatus_Reports_DownloadignInprogress
                            "
                            class="downloading-status d-flex flex-column align-items-start ml-3"
                            style="margin-left: 25px"
                          >
                            <div class="d-flex align-items-center">
                              <i class="fa fa-spinner fa-spin mr-2"></i>
                              <span>Report Generation In Progress...</span>
                            </div>
                            <small class="text-danger mt-1">
                              <strong>Note:</strong> The requested report is
                              currently being generated. Once completed, you can
                              download it by clicking on the
                              <strong>"Generate Report"</strong> button. Click
                              <i class="fas fa-sync-alt mr-2"></i> Refresh to
                              check the status.
                            </small>
                          </div>

                          <button
                            *ngIf="
                              !hidePreviousePrepaidMeterOffStatus_Reports_availableBtn &&
                              isPrepaidMeterOffStatus_Reports_DownloadedLinkAvailable
                            "
                            class="btn btn-primary btn-md d-flex align-items-center ml-3"
                            style="margin-left: 10px"
                            (click)="downloadPrepaidMeterOffStatus_ReportFile()"
                          >
                            <i
                              class="fa fa-file-download mr-2"
                              style="margin-right: 10px"
                            ></i
                            >Generate Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </accordion-group>

                <!-- Activation Status -->

                <accordion-group
                  *ngIf="role == listOfRoles.ADMIN"
                  [isOpen]="true"
                  heading="1. Activation Status"
                  class="accordion-item"
                  #group1
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group1?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon'
                          : 'mdi mdi-chevron-up accor-plus-icon'
                      "
                    ></i>
                  </span>

                  <div class="text-muted">
                    <div class="row">
                      <!-- Status -->
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Status <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="Activation_Status"
                            placeholder="Select Status"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="select_Status"
                            [multiple]="false"
                            [clearable]="false"
                            [deselectOnClick]="false"
                          >
                          </ng-select>
                        </div>
                      </div>

                      <!-- Utilities -->
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Utilities <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="utilityList"
                            placeholder="Select Utilities"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectedUtility"
                            (change)="onFilterUtilitiesChange($event)"
                            (add)="onSelectUtility($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>
                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              selectedUtility.length == 0 &&
                              utilityValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ utilityValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <!-- Activated b/w -->
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Activated b/w </label>
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control date"
                              [value]="
                                activationDateRange
                                  ? formatDateRange(activationDateRange)
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #activationPicker="bsDaterangepicker"
                              (onShown)="
                                onRangePickerShown(
                                  activationPicker,
                                  'activationDateRange',
                                  'activationDatePickerConfig',
                                  true
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  activationPicker,
                                  'activationDateRange'
                                )
                              "
                              [bsConfig]="getActivationConfig()"
                              [(bsValue)]="activationDateRange"
                              (bsValueChange)="
                                onActivationDateRangeChange($event)
                              "
                            />
                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendar()"
                            ></span>
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="activationDateRange.length > 0"
                              (click)="clearDate()"
                            ></span>
                          </div>

                          <!-- <div *ngIf="activationDateRange.length==0&&dateRangeValidationMessage" class="text-danger mt-2">
                            {{ dateRangeValidationMessage }}
                          </div> -->
                        </div>
                        <div>
                          <small
                            class="text-muted required d-block mt-0 text-nowrap"
                          >
                            <strong>Note: </strong>If no date range is selected,
                            the report will include data up to the current date.
                          </small>
                        </div>
                      </div>

                      <div class="col-lg-3 align-items-center sm-btn mt-4">
                        <button
                          class="btn btn-primary btn-md"
                          style="margin-top: 0px"
                          (click)="exportActionStatus()"
                        >
                          Export
                        </button>
                      </div>
                      <!-- Export Button -->
                      <!-- <div class="col-lg-3  d-flex align-items-center sm-btn mt-4">
                        <button class="btn btn-primary" style="margin-top:3px"  (click)="exportActionStatus()" > Export </button>
                      </div> -->
                    </div>
                  </div>
                </accordion-group>

                <accordion-group
                  *ngIf="role == listOfRoles.ADMIN"
                  [isOpen]="isConsumptionOpen"
                  heading="2. Consumption Reports"
                  class="accordion-item"
                  #group2
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group2?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon'
                          : 'mdi mdi-chevron-up accor-plus-icon'
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Range <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="rangeList"
                            placeholder="Select Utilities"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="consumption_selectedRange"
                            [multiple]="false"
                            [deselectOnClick]="false"
                            [clearable]="false"
                          >
                          </ng-select>
                          <div
                            *ngIf="consumptionDateRangeValidationMessage != ''"
                            class="text-danger mt-2"
                          >
                            {{ consumptionDateRangeValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Utilities <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="utilityList"
                            placeholder="Select Utilities"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="consumption_selectedUtility"
                            (change)="onFilterUtilitiesChange($event)"
                            (add)="onSelectUtilityInConsumption($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="utilityConsumptionValidationMessage"
                            class="text-danger mt-2"
                          >
                            {{ utilityConsumptionValidationMessage }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Date Range <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control dateconsumetion"
                              [value]="
                                consumptionDateRange
                                  ? formatDateRange(consumptionDateRange)
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #consumptionPicker="bsDaterangepicker"
                              (onShown)="
                                onRangePickerShown(
                                  consumptionPicker,
                                  'consumptionDateRange',
                                  'adminDateRangePickerConfig'
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  consumptionPicker,
                                  'consumptionDateRange'
                                )
                              "
                              [bsConfig]="
                                getRangeConfig(
                                  'consumptionDateRange',
                                  'adminDateRangePickerConfig'
                                )
                              "
                              [(bsValue)]="consumptionDateRange"
                              (bsValueChange)="
                                onGenericDateRangeChange(
                                  $event,
                                  'consumptionDateRange',
                                  'adminDateRangePickerConfig'
                                )
                              "
                            />
                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendarConsumption()"
                            ></span>
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="consumptionDateRange.length > 0"
                              (click)="clearConsumptionDate()"
                            ></span>
                          </div>
                          <div
                            *ngIf="dateRangeValidationMessage"
                            class="text-danger mt-2"
                          >
                            {{ dateRangeValidationMessage }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Flat Number </label>
                          <ng-select
                            [items]="flatnumbersList"
                            placeholder="Select Flats"
                            bindLabel="flatNo"
                            bindValue="id"
                            [(ngModel)]="Consumption_selectedFlatNumber"
                            (change)="onFilterFlatsChange($event)"
                            (add)="onSelectFlatsInConsumption($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.flatNo
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.flatNo"
                                  >{{ item?.flatNo }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <!--  <div *ngIf="flatNumberValidationMessage" class="text-danger mt-2">
                            {{ flatNumberValidationMessage }}
                          </div> -->
                        </div>
                      </div>
                      <div class="col-lg-12 align-items-center sm-btn mt-4">
                        <!-- <button class="btn btn-primary btn-md" [disabled]="false" (click)="exportConsumptionReport()">
                          Export
                        </button> -->

                        <div class="col-lg-5 d-flex align-items-center mt-3">
                          <!-- Export Button with Margin -->
                          <button
                            *ngIf="!isConsumptionDownloadignInprogress"
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="exportConsumptionReport()"
                          >
                            Export
                          </button>

                          <button
                            *ngIf="isConsumptionDownloadignInprogress"
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="
                              getLatestConsumptionReadingsReportStatus(
                                'getStatus'
                              )
                            "
                          >
                            <i class="fas fa-sync-alt mr-2"></i>
                          </button>

                          <div
                            *ngIf="isConsumptionDownloadignInprogress"
                            class="downloading-status d-flex flex-column align-items-start ml-3"
                            style="margin-left: 25px"
                          >
                            <div class="d-flex align-items-center">
                              <i class="fa fa-spinner fa-spin mr-2"></i>
                              <span>Report Generation In Progress...</span>
                            </div>
                            <small class="text-danger mt-1">
                              <strong>Note:</strong> The requested report is
                              currently being generated. Once completed, you can
                              download it by clicking on the
                              <strong>"Generated Report"</strong> button. Click
                              <i class="fas fa-sync-alt mr-2"></i> Refresh to
                              check the status.
                            </small>
                          </div>

                          <!-- Previous Downloaded File Button with Margin -->
                          <button
                            *ngIf="
                              !hidePreviouseConsumptionavailableBtn &&
                              isConsumptionDownloadedLinkAvailable
                            "
                            class="btn btn-primary btn-md d-flex align-items-center ml-3"
                            style="margin-left: 10px"
                            (click)="downloadPreviousConsumptionReportFile()"
                          >
                            <i
                              class="fa fa-file-download mr-2"
                              style="margin-right: 10px"
                            ></i
                            >Generated Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </accordion-group>
                <!-- <accordion-group *ngIf="role == (listOfRoles.ADMIN)" [isOpen]="isConsumptionOpen"
                  heading="3.Daily Consumption Reports" class="accordion-item" #group2>
                  <span accordion-heading class="float-end fs-5 d-flex align-items-center">
                    <i class="mdi font-size-24"
                      [ngClass]="!group2?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon' : 'mdi mdi-chevron-up accor-plus-icon'"></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Utilities <span class="required">*</span></label>
                          <ng-select [items]="utilityList" placeholder="Select Utilities" bindLabel="name"
                            bindValue="id" [(ngModel)]="dailyconsumption_selectedUtility"
                            (change)="onFilterUtilitiesChange($event)" (add)="onSelectUtilityInDailyConsumption($event)"
                            [multiple]="true" [deselectOnClick]="true">

                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                              <span class="ng-value-label">{{ item?.name }}</span>
                              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">&times;</span>
                            </ng-template>

                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                              <div class="ng-value" *ngFor="let item of items.slice(0,2)">
                                <span class="ng-value-label" *ngIf="item?.name">{{ item?.name }}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">&times;</span>
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
                              </div>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="utilityValidationMessage" class="text-danger mt-2">
                            {{ dailyutilityValidationMessage }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Date Range <span class="required">*</span></label>
                          <div class="position-relative">
                            <input type="text" class="form-control dailyconsumetion"
                              [value]="dailyconsumptionDateRange ? (formatDateRange(dailyconsumptionDateRange)) : ''"
                              placeholder="Select Date" name="daterange" autocomplete="off" bsDaterangepicker
                              #dailyConsumptionPicker="bsDaterangepicker"
                              (onShown)="onRangePickerShown(dailyConsumptionPicker, 'dailyconsumptionDateRange', 'datePickerConfig')"
                              (onHidden)="onRangePickerHidden(dailyConsumptionPicker, 'dailyconsumptionDateRange')"
                              [bsConfig]="getRangeConfig('dailyconsumptionDateRange', 'datePickerConfig')"
                              [(bsValue)]="dailyconsumptionDateRange"
                              (bsValueChange)="onGenericDateRangeChange($event, 'dailyconsumptionDateRange', 'datePickerConfig')" />
                            <span class="bx bx-calendar inputIcon" (click)="openCalendardailyConsumption()"></span>
                            <span class="bx bx-x inputIcon clear-icon" *ngIf="dailyconsumptionDateRange.length > 0"
                              (click)="cleardailyConsumptionDate()"></span>

                          </div>
                          <div *ngIf="dailydateRangeValidationMessage" class="text-danger mt-2">
                            {{ dailydateRangeValidationMessage }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Flat Number <span class="required">*</span></label>
                          <ng-select [items]="flatnumbersList" placeholder="Select Flats" bindLabel="flatNo"
                            bindValue="id" [(ngModel)]="dailyConsumption_selectedFlatNumber"
                            (change)="onFilterFlatsChange($event)" (add)="onSelectFlatsIndailyConsumption($event)"
                            [multiple]="true" [deselectOnClick]="true">

                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                              <span class="ng-value-label">{{ item?.flatNo }}</span>
                              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">&times;</span>
                            </ng-template>

                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                              <div class="ng-value" *ngFor="let item of items.slice(0,2)">
                                <span class="ng-value-label" *ngIf="item?.flatNo">{{ item?.flatNo }}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">&times;</span>
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-lg-3  align-items-center sm-btn mt-4">
                        <button class="btn btn-primary btn-md " [disabled]="false"
                          (click)="exportDailyConsumptionReport()"> Export
                        </button>
                      </div>
                    </div>
                  </div>

                </accordion-group> -->

                <accordion-group
                  *ngIf="role == listOfRoles.ADMIN"
                  [isOpen]="false"
                  [heading]="
                    billingType === 'Prepaid'
                      ? '3.Statement  Consumption Reports'
                      : '3. Bill Wise Consumption Reports'
                  "
                  class="accordion-item"
                  #group3
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group3?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon'
                          : 'mdi mdi-chevron-up accor-plus-icon'
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Utilities <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="utilityList"
                            placeholder="Select Utilities"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="billwise_selectedUtility"
                            (change)="onFilterUtilitiesChange($event)"
                            (add)="onSelectUtilityInBillWiseConsumption($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              billwise_selectedUtility == 0 &&
                              utilityValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ utilityValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Months <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <ng-select
                              [items]="monthsList"
                              placeholder="Select Month"
                              [(ngModel)]="selectedMonth"
                              (change)="onFilterMonthsChange($event)"
                              [multiple]="false"
                              [clearable]="false"
                              [deselectOnClick]="false"
                            >
                            </ng-select>

                            <!-- <ng-select 
                              [items]="monthsList" 
                              placeholder="Select Month"
                              [(ngModel)]="selectedMonth"
                              (change)="onFilterMonthsChange($event)"
                              [multiple]="false"
                              [deselectOnClick]="true"
                              [clearable]="false"
                            >
                              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                <span class="ng-value-label">{{ item }}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">&times;</span>
                              </ng-template>
                      
                              <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items.slice(0,2)">
                                  <span class="ng-value-label">{{ item }}</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 2">
                                  <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
                                </div>
                              </ng-template>
                            </ng-select> -->
                            <div
                              *ngIf="!selectedMonth && monthValidationMessage"
                              class="text-danger mt-2"
                            >
                              {{ monthValidationMessage }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Select Year & Month</label>
                          <div class="position-relative">
                            <input type="text" class="form-control settlement"
                              placeholder="Select Year & Month"
                              name="yearMonthPicker"
                              autocomplete="off"
                              bsDatepicker
                              [bsConfig]="datePickerConfigwithYearSelection"
                              [(bsValue)]="selectedYearMonth"
                              (bsValueChange)="onValueChange($event)"
                              #datePicker="bsDatepicker" />
                          </div>
                        </div>
                      </div> -->

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Flat Number <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="flatnumbersList"
                            placeholder="Select Flats"
                            bindLabel="flatNo"
                            bindValue="id"
                            [(ngModel)]="billwise_selectedFlatNumber"
                            (change)="onFilterFlatsChange($event)"
                            (add)="onSelectFlatsInBillWiseConsumption($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.flatNo
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.flatNo"
                                  >{{ item?.flatNo }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              billwise_selectedFlatNumber.length == 0 &&
                              flatNumberValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ flatNumberValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 align-items-center sm-btn mt-4">
                        <button
                          class="btn btn-primary btn-md"
                          [disabled]="false"
                          style="margin-top: 0px"
                          (click)="exportBillWiseConsumptionReports()"
                        >
                          Export
                        </button>
                      </div>
                    </div>
                  </div>
                </accordion-group>

                <accordion-group
                  *ngIf="role == listOfRoles.ADMIN"
                  [isOpen]="isDeviceCommunication"
                  heading="4. Device Communication Reports"
                  class="accordion-item"
                  #group4
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group4?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon'
                          : 'mdi mdi-chevron-up accor-plus-icon'
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Utilities <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="utilityList"
                            placeholder="Select Utilities"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="deviceCommunication_selectedUtility"
                            (change)="onFilterUtilitiesChange($event)"
                            (add)="onSelectUtilityInDeviceCommunication($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              deviceCommunication_selectedUtility == 0 &&
                              utilityValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ utilityValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Date Range <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control datedeviceCommunication"
                              [value]="
                                deviceCommunicationDateRange
                                  ? formatDateRange(
                                      deviceCommunicationDateRange
                                    )
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #deviceCommunicationPicker="bsDaterangepicker"
                              (onShown)="
                                onRangePickerShown(
                                  deviceCommunicationPicker,
                                  'deviceCommunicationDateRange',
                                  'deviceCommunicationdatePickerConfig'
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  deviceCommunicationPicker,
                                  'deviceCommunicationDateRange'
                                )
                              "
                              [bsConfig]="
                                getRangeConfig(
                                  'deviceCommunicationDateRange',
                                  'deviceCommunicationdatePickerConfig'
                                )
                              "
                              [(bsValue)]="deviceCommunicationDateRange"
                              (bsValueChange)="
                                onGenericDateRangeChange(
                                  $event,
                                  'deviceCommunicationDateRange',
                                  'deviceCommunicationdatePickerConfig'
                                )
                              "
                            />
                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendarDeviceCommunication()"
                            ></span>
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="deviceCommunicationDateRange.length > 0"
                              (click)="clearDeviceCommunicationDate()"
                            ></span>
                          </div>
                          <div
                            *ngIf="
                              deviceCommunicationDateRange.length != 2 &&
                              DeviceCommunicationdateRangeValidationMessage !=
                                ''
                            "
                            class="text-danger mt-2"
                          >
                            {{ DeviceCommunicationdateRangeValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Flat Number <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="flatnumbersList"
                            placeholder="Select Flats"
                            bindLabel="flatNo"
                            bindValue="id"
                            [(ngModel)]="deviceCommunication_selectedFlatNumber"
                            (change)="onFilterFlatsChange($event)"
                            (add)="onSelectFlatsInDeviceCommunication($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.flatNo
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.flatNo"
                                  >{{ item?.flatNo }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              deviceCommunication_selectedFlatNumber.length ==
                                0 && flatNumberValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ flatNumberValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Active Status
                            <span class="required">*</span></label
                          >

                          <ng-select
                            [items]="Activation_Status"
                            placeholder="Select Active Status"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectActivationStatus"
                            (change)="onFilterFlatsChange($event)"
                            [multiple]="false"
                            [clearable]="false"
                            [deselectOnClick]="false"
                          >
                          </ng-select>
                          <div
                            *ngIf="
                              billwise_selectedFlatNumber.length == 0 &&
                              selectActivationStatusValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ selectActivationStatusValidationMessage }}
                          </div>
                        </div>
                      </div>
                      <!-- santosh commented -->
                      <!-- <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">MCB<span class="required">*</span></label>
                          <ng-select [items]="Mcb_Status" placeholder="Select Mcb" bindLabel="name" bindValue="id"
                            [(ngModel)]="selecteddeviceCommunicationMcb" (change)="onFilterFlatsChange($event)"
                            [multiple]="false" [deselectOnClick]="false" [clearable]="false">
                          </ng-select>
                          <div *ngIf="selecteddeviceCommunicationMcb.length==0&&flatNumberValidationMessage"
                            class="text-danger mt-2">
                            {{ flatNumberValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Valve Status<span class="required">*</span></label>
                          <ng-select [items]="Valve_Status" placeholder="Select Valve Status" bindLabel="name"
                            bindValue="id" [(ngModel)]="selectedValve_Status" (change)="onFilterFlatsChange($event)"
                            [multiple]="false" [deselectOnClick]="false" [clearable]="false">
                          </ng-select>
                          <div *ngIf="selectedValve_Status.length==0&&flatNumberValidationMessage"
                            class="text-danger mt-2">
                            {{ flatNumberValidationMessage }}
                          </div>
                        </div>
                      </div> -->

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Communicating Status<span class="required"
                              >*</span
                            ></label
                          >
                          <ng-select
                            [items]="Communication_Status"
                            placeholder="Select Communicating Status"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectedCommnunicationStatus"
                            (change)="onFilterFlatsChange($event)"
                            [multiple]="false"
                            [deselectOnClick]="false"
                            [clearable]="false"
                          >
                          </ng-select>
                          <div
                            *ngIf="
                              selectedCommnunicationStatus.length == 0 &&
                              flatNumberValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ flatNumberValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <!-- <div class="col-lg-3  align-items-center sm-btn mt-4">
                        <button class="btn btn-primary btn-md " [disabled]="false"
                          (click)="exportDeviceCommunicationReports()"> Export
                        </button>
                      </div> -->

                      <div class="col-lg-10 d-flex align-items-center mt-3">
                        <!-- Export Button with Margin -->
                        <button
                          *ngIf="!isDeviceCommunicationDownloadignInprogress"
                          class="btn btn-primary btn-md"
                          [disabled]="false"
                          (click)="exportDeviceCommunicationReports()"
                        >
                          Export
                        </button>

                        <button
                          *ngIf="isDeviceCommunicationDownloadignInprogress"
                          class="btn btn-primary btn-md"
                          [disabled]="false"
                          (click)="
                            getLatestDeviceCommunicationReportStatus(
                              'getStatus'
                            )
                          "
                        >
                          <i class="fas fa-sync-alt mr-2"></i>
                        </button>

                        <div
                          *ngIf="isDeviceCommunicationDownloadignInprogress"
                          class="downloading-status d-flex flex-column align-items-start ml-3"
                          style="margin-left: 25px"
                        >
                          <div class="d-flex align-items-center">
                            <i class="fa fa-spinner fa-spin mr-2"></i>
                            <span>Report Generation In Progress...</span>
                          </div>
                          <small class="text-danger mt-1">
                            <strong>Note:</strong> The requested report is
                            currently being generated. Once completed, you can
                            download it by clicking on the
                            <strong>"Generated Report"</strong> button. Click
                            <i class="fas fa-sync-alt mr-2"></i> Refresh to
                            check the status.
                          </small>
                        </div>
                        <!-- Previous Downloaded File Button with Margin -->
                        <button
                          *ngIf="
                            !hidePreviouseDeviceCommunicationReportavailableBtn &&
                            isDeviceCommunicationDownloadedLinkAvailable
                          "
                          class="btn btn-primary btn-md d-flex align-items-center ml-3"
                          style="margin-left: 10px"
                          (click)="
                            downloadPreviousDeviceCommunicationReportFile()
                          "
                        >
                          <i
                            class="fa fa-file-download mr-2"
                            style="margin-right: 10px"
                          ></i
                          >Generated Report
                        </button>
                      </div>
                    </div>
                  </div>
                </accordion-group>

                <accordion-group
                  *ngIf="role == listOfRoles.ADMIN"
                  [isOpen]="false"
                  heading="5.Meter Reading Reports"
                  class="accordion-item"
                  #group5
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group5?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon'
                          : 'mdi mdi-chevron-up accor-plus-icon'
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="mb-3">
                          <label class="form-label"
                            >Utilities <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="utilityList"
                            placeholder="Select Utilities"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="meterReading_selectedUtility"
                            (change)="onFilterUtilitiesChange($event)"
                            (add)="onSelectUtilityInMeterReading($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              meterReading_selectedUtility == 0 &&
                              utilityValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ utilityValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="mb-3">
                          <label class="form-label">Flat Number</label>
                          <ng-select
                            [items]="flatnumbersList"
                            placeholder="Select Flats"
                            bindLabel="flatNo"
                            bindValue="id"
                            [(ngModel)]="meterReading_selectedFlatNumber"
                            (change)="onFilterFlatsChange($event)"
                            (add)="onSelectFlatsInMeterReadings($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.flatNo
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.flatNo"
                                  >{{ item?.flatNo }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <!-- <div *ngIf="meterReading_selectedFlatNumber.length==0&&flatNumberValidationMessage"
                            class="text-danger mt-2">
                            {{ flatNumberValidationMessage }}
                          </div> -->
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="mb-3">
                          <label class="form-label"
                            >Date Range <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control datemeterReading"
                              [value]="
                                meterReadingDateRange
                                  ? formatDateRange(meterReadingDateRange)
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #meterReadingPicker="bsDaterangepicker"
                              (onShown)="
                                onRangePickerShown(
                                  meterReadingPicker,
                                  'meterReadingDateRange',
                                  'meterReadingsReportDates'
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  meterReadingPicker,
                                  'meterReadingDateRange'
                                )
                              "
                              [bsConfig]="
                                getRangeConfig(
                                  'meterReadingDateRange',
                                  'meterReadingsReportDates'
                                )
                              "
                              [(bsValue)]="meterReadingDateRange"
                              (bsValueChange)="
                                onGenericDateRangeChange(
                                  $event,
                                  'meterReadingDateRange',
                                  'meterReadingsReportDates'
                                )
                              "
                            />
                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendarMeterReading()"
                            ></span>
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="meterReadingDateRange.length > 0"
                              (click)="clearMeterReadingDate()"
                            ></span>
                          </div>
                        </div>
                        <p
                          *ngIf="
                            meterReadingDateRange.length != 2 &&
                            meterreadingdateRangeValidationMessage
                          "
                          class="text-danger mt-2"
                        >
                          {{ meterreadingdateRangeValidationMessage }}
                        </p>
                      </div>

                      <div class="col-lg-12 d-flex align-items-center mt-3">
                        <!-- Export Button with Margin -->
                        <button
                          *ngIf="!ismeterDownloadignInprogress"
                          class="btn btn-primary btn-md"
                          [disabled]="false"
                          (click)="exportMeterReadingReports()"
                        >
                          Export
                        </button>

                        <button
                          *ngIf="ismeterDownloadignInprogress"
                          class="btn btn-primary btn-md"
                          [disabled]="false"
                          (click)="
                            getLatestMeterReadingsReportStatus('getStatus')
                          "
                        >
                          <i class="fas fa-sync-alt mr-2"></i>
                        </button>

                        <div
                          *ngIf="ismeterDownloadignInprogress"
                          class="downloading-status d-flex flex-column align-items-start ml-3"
                          style="margin-left: 25px"
                        >
                          <div class="d-flex align-items-center">
                            <i class="fa fa-spinner fa-spin mr-2"></i>
                            <span>Report Generation In Progress...</span>
                          </div>
                          <small class="text-danger mt-1">
                            <strong>Note:</strong> The requested report is
                            currently being generated. Once completed, you can
                            download it by clicking on the
                            <strong>"Generated Report"</strong> button. Click
                            <i class="fas fa-sync-alt mr-2"></i> Refresh to
                            check the status.
                          </small>
                        </div>

                        <!-- Previous Downloaded File Button with Margin -->
                        <button
                          *ngIf="
                            !hidePreviouseMeteravailableBtn &&
                            isMeterDownloadedLinkAvailable
                          "
                          class="btn btn-primary btn-md d-flex align-items-center ml-3"
                          style="margin-left: 10px; margin-bottom: 0px"
                          (click)="downloadPreviousMeterReportFile()"
                        >
                          <i
                            class="fa fa-file-download mr-2"
                            style="margin-right: 10px"
                          ></i
                          >Generated Report
                        </button>
                      </div>
                    </div>
                  </div>
                </accordion-group>
                <accordion-group
                  *ngIf="role == listOfRoles.ADMIN && billingType == 'Postpaid'"
                  [isOpen]="false"
                  heading="6.Billing and Collection Report"
                  class="accordion-item"
                  #group6
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group6?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon'
                          : 'mdi mdi-chevron-up accor-plus-icon'
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Utilities <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="utilityList"
                            placeholder="Select Utilities"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="billgeneration_selectedUtility"
                            (change)="onFilterUtilitiesChange($event)"
                            (add)="
                              onSelectUtilityInBillGenerationMeterReading(
                                $event
                              )
                            "
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              billgeneration_selectedUtility == 0 &&
                              utilityValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ utilityValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Date Range <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control datebillGeneration"
                              [value]="
                                billGenerationDateRange
                                  ? formatDateRange(billGenerationDateRange)
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #billGenerationPicker="bsDaterangepicker"
                              (onShown)="
                                onRangePickerShown(
                                  billGenerationPicker,
                                  'billGenerationDateRange',
                                  'billGenerationDatePickerConfig'
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  billGenerationPicker,
                                  'billGenerationDateRange'
                                )
                              "
                              [bsConfig]="
                                getRangeConfig(
                                  'billGenerationDateRange',
                                  'billGenerationDatePickerConfig'
                                )
                              "
                              [(bsValue)]="billGenerationDateRange"
                              (bsValueChange)="
                                onGenericDateRangeChange(
                                  $event,
                                  'billGenerationDateRange',
                                  'billGenerationDatePickerConfig'
                                )
                              "
                            />
                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendarBillGeneration()"
                            ></span>
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="billGenerationDateRange.length > 0"
                              (click)="clearbillGenerationDate()"
                            ></span>
                          </div>
                          <div
                            *ngIf="
                              billGenerationDateRange.length != 2 &&
                              billgendateRangeValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ billgendateRangeValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Flat Number <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="flatnumbersList"
                            placeholder="Select Flats"
                            bindLabel="flatNo"
                            bindValue="id"
                            [(ngModel)]="billGeneration_selectedFlatNumber"
                            (change)="onFilterFlatsChange($event)"
                            (add)="onSelectFlatsInBillGeneration($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.flatNo
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.flatNo"
                                  >{{ item?.flatNo }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              billGeneration_selectedFlatNumber.length == 0 &&
                              flatNumberValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ flatNumberValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Status<span class="required">*</span></label
                          >
                          <ng-select
                            [items]="BillStatis"
                            placeholder="Select Valve Status"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selectedValve_Status_MeterReadings"
                            (change)="onFilterFlatsChange($event)"
                            [multiple]="false"
                            [deselectOnClick]="false"
                            [clearable]="false"
                          >
                          </ng-select>
                          <div
                            *ngIf="
                              selectedValve_Status_MeterReadings.length == 0 &&
                              flatNumberValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ flatNumberValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 align-items-center sm-btn mt-4">
                        <button
                          class="btn btn-primary btn-md"
                          (click)="exportBillGenerationReports()"
                        >
                          Export
                        </button>
                      </div>
                    </div>
                  </div>
                </accordion-group>

                <accordion-group
                  *ngIf="
                    role === listOfRoles.ADMIN &&
                    (billingType === 'Prepaid' ||
                      (billingType === 'Postpaid' && walletStatus))
                  "
                  [isOpen]="iswalletBalnceReport"
                  [heading]="
                    billingType === 'Prepaid'
                      ? '6. Consumer wallet Reports'
                      : '7. Consumer wallet Reports'
                  "
                  class="accordion-item"
                  #group7
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group7?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon'
                          : 'mdi mdi-chevron-up accor-plus-icon'
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Date Range <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control datewalletBalanceReport"
                              [value]="
                                walletBalanceDateRange
                                  ? formatDateRange(walletBalanceDateRange)
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #walletBalancePicker="bsDaterangepicker"
                              [bsConfig]="
                                getRangeConfig(
                                  'walletBalanceDateRange',
                                  'Wallet_datePickerConfig'
                                )
                              "
                              (onShown)="
                                onRangePickerShown(
                                  walletBalancePicker,
                                  'walletBalanceDateRange',
                                  'Wallet_datePickerConfig'
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  walletBalancePicker,
                                  'walletBalanceDateRange'
                                )
                              "
                              (bsValueChange)="
                                onGenericDateRangeChange(
                                  $event,
                                  'walletBalanceDateRange',
                                  'Wallet_datePickerConfig'
                                )
                              "
                              [(bsValue)]="walletBalanceDateRange"
                            />

                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendarWalletBalance()"
                            ></span>
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="walletBalanceDateRange.length > 0"
                              (click)="clearwalletBalanceDate()"
                            ></span>
                          </div>
                          <div
                            *ngIf="
                              walletBalanceDateRange.length != 2 &&
                              consymerWalletdateRangeValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ consymerWalletdateRangeValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Status <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="WalletBalance_Status"
                            placeholder="Select Status"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selected_walletbalance"
                            (change)="onFilteWalletChange($event)"
                            (add)="onSelectWalletType($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="
                              selected_walletbalance.length == 0 &&
                              flatNumberValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ flatNumberValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Flat Number </label>
                          <ng-select
                            [items]="flatnumbersList"
                            placeholder="Select Flats"
                            bindLabel="flatNo"
                            bindValue="id"
                            [(ngModel)]="wallet_selectedFlatNumber"
                            (change)="onFilterWalletFlatsChange($event)"
                            (add)="onSelectFlatsInWalletBalance($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.flatNo
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.flatNo"
                                  >{{ item?.flatNo }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <!--  <div *ngIf="flatNumberValidationMessage" class="text-danger mt-2">
                          {{ flatNumberValidationMessage }}
                        </div> -->
                        </div>
                      </div>

                      <div class="col-lg-3 align-items-center sm-btn mt-4">
                        <button
                          class="btn btn-primary btn-md"
                          style="margin-top: 0px"
                          (click)="exportWalletBalanceReports()"
                        >
                          Export
                        </button>
                      </div>
                    </div>
                  </div>
                </accordion-group>

                <accordion-group
                  *ngIf="
                    role === listOfRoles.ADMIN &&
                    (billingType === 'Prepaid' ||
                      (billingType === 'Postpaid' && walletStatus))
                  "
                  [isOpen]="iswalleHistoryReportOpen"
                  [heading]="
                    billingType === 'Prepaid'
                      ? '7. Wallet History Reports'
                      : '8. Wallet History Reports'
                  "
                  class="accordion-item"
                  #group8
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group8?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon'
                          : 'mdi mdi-chevron-up accor-plus-icon'
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Date Range <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control datewalletHistory"
                              [value]="
                                walletHistoryDateRange
                                  ? formatDateRange(walletHistoryDateRange)
                                  : ''
                              "
                              placeholder="Select Date"
                              name="daterange"
                              autocomplete="off"
                              bsDaterangepicker
                              #walletHistoryPicker="bsDaterangepicker"
                              (onShown)="
                                onRangePickerShown(
                                  walletHistoryPicker,
                                  'walletHistoryDateRange',
                                  'walletHistoryDatePickerConfig'
                                )
                              "
                              (onHidden)="
                                onRangePickerHidden(
                                  walletHistoryPicker,
                                  'walletHistoryDateRange'
                                )
                              "
                              [bsConfig]="
                                getRangeConfig(
                                  'walletHistoryDateRange',
                                  'walletHistoryDatePickerConfig'
                                )
                              "
                              [(bsValue)]="walletHistoryDateRange"
                              (bsValueChange)="
                                onGenericDateRangeChange(
                                  $event,
                                  'walletHistoryDateRange',
                                  'walletHistoryDatePickerConfig'
                                )
                              "
                            />
                            <span
                              class="bx bx-calendar inputIcon"
                              (click)="openCalendarWalletHistory()"
                            ></span>
                            <span
                              class="bx bx-x inputIcon clear-icon"
                              *ngIf="walletHistoryDateRange.length > 0"
                              (click)="clearwalletHistoryDate()"
                            ></span>
                          </div>
                          <div
                            *ngIf="
                              walletHistoryDateRange.length != 2 &&
                              waleyHistorydateRangeValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ waleyHistorydateRangeValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Utilities <span class="required">*</span></label
                          >
                          <ng-select
                            [items]="walletHistoryUtilityList"
                            placeholder="Select Utilities"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="walletHistory_selectedUtility"
                            (change)="onFilterUtilitiesChange($event)"
                            (add)="onSelectUtilityInWalletHistoryReport($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <!-- Template for displaying selected items with cross icon -->
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <!-- Cross icon to clear the selected item -->
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <!-- Multi-label template for displaying multiple selected items -->
                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <!-- Cross icon for removing items -->
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>

                          <div
                            *ngIf="
                              walletHistory_selectedUtility == 0 &&
                              utilityValidationMessage
                            "
                            class="text-danger mt-2"
                          >
                            {{ utilityValidationMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Flat Number<span class="required">*</span></label
                          >
                          <ng-select
                            [items]="flatnumbersList"
                            placeholder="Select Flats"
                            bindLabel="flatNo"
                            bindValue="id"
                            [(ngModel)]="wallet_FlatNumber"
                            (change)="onFilterWalletFlatsChange($event)"
                            (add)="onSelectFlatsInWalletHistory($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.flatNo
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.flatNo"
                                  >{{ item?.flatNo }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <div
                            *ngIf="walletreportFaltValiadtion"
                            class="text-danger mt-2"
                          >
                            {{ walletreportFaltValiadtion }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label">Consumers</label>
                          <ng-select
                            [items]="consumersIdsList"
                            placeholder="Select Consumers"
                            bindLabel="name"
                            bindValue="id"
                            [(ngModel)]="selected_Consumers"
                            (change)="onFilterWalletConsumersChange($event)"
                            (add)="onSelectConsumersInWalletHistory($event)"
                            [multiple]="true"
                            [deselectOnClick]="true"
                          >
                            <ng-template
                              ng-label-tmp
                              let-item="item"
                              let-clear="clear"
                            >
                              <span class="ng-value-label">{{
                                item?.name
                              }}</span>
                              <span
                                class="ng-value-icon right"
                                (click)="clear(item)"
                                aria-hidden="true"
                                >&times;</span
                              >
                            </ng-template>

                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div
                                class="ng-value"
                                *ngFor="let item of items.slice(0, 2)"
                              >
                                <span
                                  class="ng-value-label"
                                  *ngIf="item?.name"
                                  >{{ item?.name }}</span
                                >
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label"
                                  >+ {{ items.length - 2 }} more</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                          <!-- <div *ngIf="consumervaliadationMessage" class="text-danger mt-2">
                            {{ consumervaliadationMessage }}
                          </div> -->
                        </div>
                      </div>

                      <!--  <div class="col-lg-3  align-items-center sm-btn mt-4">
                        <button class="btn btn-primary btn-md " style="margin-top:0px"
                          (click)="exportWalletHistoryReports()"> Export 
                        </button>
                      </div> -->
                      <div class="col-lg-12 align-items-center sm-btn mt-4">
                        <div class="col-lg-5 d-flex align-items-center mt-3">
                          <!-- Export Button with Margin -->
                          <button
                            *ngIf="!iswalletHistory_DownloadignInprogress"
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="exportWalletHistoryReports()"
                          >
                            Export
                          </button>

                          <button
                            *ngIf="iswalletHistory_DownloadignInprogress"
                            class="btn btn-primary btn-md"
                            [disabled]="false"
                            (click)="
                              getLatestWalletHistoryReportStatus('getStatus')
                            "
                          >
                            <i class="fas fa-sync-alt mr-2"></i>
                          </button>

                          <div
                            *ngIf="iswalletHistory_DownloadignInprogress"
                            class="downloading-status d-flex flex-column align-items-start ml-3"
                            style="margin-left: 25px"
                          >
                            <div class="d-flex align-items-center">
                              <i class="fa fa-spinner fa-spin mr-2"></i>
                              <span>Report Generation In Progress...</span>
                            </div>
                            <small class="text-danger mt-1">
                              <strong>Note:</strong> The requested report is
                              currently being generated. Once completed, you can
                              download it by clicking on the
                              <strong>"Generated Report"</strong> button. Click
                              <i class="fas fa-sync-alt mr-2"></i> Refresh to
                              check the status.
                            </small>
                          </div>

                          <!-- Previous Downloaded File Button with Margin -->
                          <button
                            *ngIf="
                              !hidePreviousewalletHistory_availableBtn &&
                              iswalletHistory_DownloadedLinkAvailable
                            "
                            class="btn btn-primary btn-md d-flex align-items-center ml-3"
                            style="margin-left: 10px"
                            (click)="downloadWallet_History_ReportFile()"
                          >
                            <i
                              class="fa fa-file-download mr-2"
                              style="margin-right: 10px"
                            ></i
                            >Generated Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </accordion-group>
                <accordion-group
                  *ngIf="
                    role === listOfRoles.ADMIN &&
                    (billingType === 'Prepaid' ||
                      (billingType === 'Postpaid' && walletStatus))
                  "
                  [isOpen]="false"
                  [heading]="
                    billingType === 'Prepaid'
                      ? '8.Wallet Month Balance report'
                      : '9.Wallet Month Balance report'
                  "
                  class="accordion-item"
                  #group3
                >
                  <span
                    accordion-heading
                    class="float-end fs-5 d-flex align-items-center"
                  >
                    <i
                      class="mdi font-size-24"
                      [ngClass]="
                        !group3?.isOpen
                          ? 'mdi mdi-chevron-down accor-plus-icon'
                          : 'mdi mdi-chevron-up accor-plus-icon'
                      "
                    ></i>
                  </span>
                  <div class="text-muted">
                    <div class="row">
                      <!-- <div class="col-lg-3">
                      <div class="mb-3">
                        <label class="form-label">Months <span class="required">*</span></label>
                        <div class="position-relative">
                          <ng-select [items]="monthsListWithAll" placeholder="Select Month" bindLabel="name" bindValue="id"
                            [(ngModel)]="selectedMonthsForWalletBalanceReport" (change)="onFilterMonthsChange($event)" (add)="onSelectMonthsForWalletBalanceReports($event)" [multiple]="true"
                            [deselectOnClick]="true" [clearable]="false">

                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                              <span class="ng-value-label">{{ item?.name }}</span>
                              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">&times;</span>
                            </ng-template>

                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                              <div class="ng-value" *ngFor="let item of items.slice(0,2)">
                                <span class="ng-value-label" *ngIf="item?.name">{{ item?.name }}</span>
                              </div>
                              <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label">+ {{ items.length - 2 }} more</span>
                              </div>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="selectedMonth==null&&monthValidationMessage" class="text-danger mt-2">
                            {{ monthValidationMessage }}
                          </div>
                        </div>
                      </div>
                    </div> -->

                      <div class="col-lg-3">
                        <div class="mb-3">
                          <label class="form-label"
                            >Months <span class="required">*</span></label
                          >
                          <div class="position-relative">
                            <!-- <ng-select [items]="monthsList" placeholder="Select Month" [(ngModel)]="selectedMonthsForWalletBalanceReport"
                            (change)="onFilterMonthsChange($event)" [multiple]="false" [clearable]="false"
                            [deselectOnClick]="false">
                          </ng-select> -->

                            <ng-select
                              [items]="monthsListWithAll"
                              placeholder="Select Month"
                              bindLabel="name"
                              bindValue="id"
                              [(ngModel)]="selectedMonthsForWalletBalanceReport"
                              (change)="onFilterMonthsChange($event)"
                              (add)="
                                onSelectMonthsForWalletBalanceReports($event)
                              "
                              [multiple]="true"
                              [deselectOnClick]="true"
                              [clearable]="true"
                            >
                              <ng-template
                                ng-label-tmp
                                let-item="item"
                                let-clear="clear"
                              >
                                <span class="ng-value-label">{{
                                  item?.name
                                }}</span>
                                <span
                                  class="ng-value-icon right"
                                  (click)="clear(item)"
                                  aria-hidden="true"
                                  >&times;</span
                                >
                              </ng-template>

                              <ng-template
                                ng-multi-label-tmp
                                let-items="items"
                                let-clear="clear"
                              >
                                <div
                                  class="ng-value"
                                  *ngFor="let item of items.slice(0, 2)"
                                >
                                  <span
                                    class="ng-value-label"
                                    *ngIf="item?.name"
                                    >{{ item?.name }}</span
                                  >
                                  <span
                                    class="ng-value-icon right"
                                    (click)="clear(item)"
                                    aria-hidden="true"
                                    >&times;</span
                                  >
                                </div>
                                <div class="ng-value" *ngIf="items.length > 2">
                                  <span class="ng-value-label"
                                    >+ {{ items.length - 2 }} more</span
                                  >
                                </div>
                              </ng-template>
                            </ng-select>

                            <div
                              *ngIf="
                                selectedMonthsForWalletBalanceReport.length ==
                                  0 && monthValidationMessage
                              "
                              class="text-danger mt-2"
                            >
                              {{ monthValidationMessage }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 align-items-center sm-btn mt-4">
                        <button
                          class="btn btn-primary btn-md"
                          style="margin-top: 0px"
                          (click)="exportMonthWiseWalletBalnceReports()"
                        >
                          Export
                        </button>
                      </div>
                    </div>
                  </div>
                </accordion-group>
              </accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
